import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { PLPHero } from 'components/plp/PLPHero/PLPHero';
import { JumpNav } from 'components/plp/JumpNav/JumpNav';
import StickyBar from 'components/plp/StickyBar/StickyBar';

import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';

import './PSPLayout.scss';

export const quickLinks = [
	{ id: 'search-storage', label: 'Search Storage' },
	{ id: 'how-it-works', label: 'How It Works' },
	{ id: 'reviews-section', label: 'Reviews' },
	{ id: 'why-ssdc', label: 'Why Us' },
];

const PSPLayout = ({ storageType, handleSearch = () => {} }) => {
	const [activeLink, setActiveLink] = useState(null);

	const handleLinkClick = useCallback(
		(linkId) => (e) => {
			e?.preventDefault?.();
			setActiveLink(linkId);

			scrollToElement(`#${linkId}`, {
				offset: -globalThis.innerHeight / 6,
				behavior: 'smooth',
			});

			const { pathname, search } = globalThis.location;
			const newUrl = `${pathname}${search}#${linkId}`;
			globalThis.history.pushState(null, '', newUrl);
		},
		[],
	);

	useEffect(() => {
		const hash = globalThis.location.hash.replace('#', '');

		if (quickLinks.some((link) => link.id == hash)) {
			setActiveLink(hash);
		}
	}, []);

	return (
		<div className={`psp-layout ${storageType}`}>
			<StickyBar
				activeLink={activeLink}
				handleLinkClick={handleLinkClick}
				handleSearch={handleSearch}
			/>
			<div
				className="psp-content"
				id="search-storage"
			>
				<PLPHero
					storageType={storageType}
					handleSearch={handleSearch}
				/>
				<JumpNav
					activeLink={activeLink}
					handleLinkClick={handleLinkClick}
				/>
			</div>
		</div>
	);
};

PSPLayout.propTypes = {
	storageType: PropTypes.string.isRequired,
	handleSearch: PropTypes.func,
};

export default PSPLayout;
